<div class="container">
  <h1>API Test Interface 2.0</h1>

  <div class="button-group">
    <h3>Endpoints:</h3>
    <button (click)="makeRequest('https://api2.yidtoyid.com/healthz')" class="api-button">
      GET - https://api2.yidtoyid.com/healthz
    </button>

    <button (click)="makeRequest('https://api2.yidtoyid.com/dummy2')" class="api-button">
      GET - https://api2.yidtoyid.com/dummy2
    </button>

    <button (click)="makeRequest('https://org2.yidtoyid.com/healthz')" class="api-button">
      GET - https://org2.yidtoyid.com/healthz
    </button>

    <button (click)="makeRequest('https://org2.yidtoyid.com/dummy2')" class="api-button">
      GET - https://org2.yidtoyid.com/dummy2
    </button>
  </div>

  @if (loading()) {
  <div class="loading">Making request...</div>
  } @if (response()) {
  <div class="response">
    <h3>Response:</h3>
    <pre>{{ response() | json }}</pre>
  </div>
  } @if (error()) {
  <div class="error">
    <h3>Error:</h3>
    <pre>{{ error() }}</pre>
  </div>
  }
</div>

<router-outlet />
